import { Box, Typography, Avatar } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Comment = ({ comment }) => {
  const users = useSelector((state) => state.users.users);

  const author = useMemo(
    () => users.find((u) => u._id === comment.commentUserId),
    [users, comment.commentUserId]
  );

  const initials = author
    ? `${author.firstName?.[0] ?? ""}${author.lastName?.[0] ?? ""}`.toUpperCase()
    : "?";

  return (
    <Box sx={{ display: "flex", gap: 1, mb: 1.5, alignItems: "flex-start" }}>
      <Link
        to={author ? `/profile/${author._id}` : "#"}
        style={{ textDecoration: "none", flexShrink: 0 }}
      >
        <Avatar
          src={author?.profilePicture}
          sx={{
            width: 30,
            height: 30,
            bgcolor: "#D4AF37",
            color: "#1A1A2E",
            fontSize: 11,
            fontWeight: 700,
            mt: 0.3,
            transition: "transform 0.15s",
            "&:hover": { transform: "scale(1.08)" },
          }}
        >
          {initials}
        </Avatar>
      </Link>

      <Box
        sx={{
          bgcolor: "#F3F4F6",
          borderRadius: "0 12px 12px 12px",
          px: 1.5,
          py: 1,
          maxWidth: "85%",
          wordBreak: "break-word",
        }}
      >
        {author && (
          <Link
            to={`/profile/${author._id}`}
            style={{ textDecoration: "none" }}
          >
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 700,
                color: "#1A1A2E",
                lineHeight: 1.2,
                mb: 0.3,
                "&:hover": { color: "#D4AF37" },
                transition: "color 0.15s",
              }}
            >
              {author.firstName} {author.lastName}
            </Typography>
          </Link>
        )}
        <Typography sx={{ fontSize: 13.5, color: "#374151", lineHeight: 1.5 }}>
          {comment.content}
        </Typography>
      </Box>
    </Box>
  );
};

export default Comment;
